export const PROTOCOL_VERSION = 1;

export type EnvelopeSource = 'mobeus-host' | 'mobeus-iframe';

export interface Envelope<T = unknown> {
  source: EnvelopeSource;
  protocolVersion: number;
  id: string;
  type: string;
  payload?: T;
}

function randomId(): string {
  return Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function makeEnvelope<T>(source: EnvelopeSource, type: string, payload?: T): Envelope<T> {
  return { source, protocolVersion: PROTOCOL_VERSION, id: randomId(), type, payload };
}

export function isValidEnvelope(msg: unknown, expectedSource: EnvelopeSource): msg is Envelope {
  if (!msg || typeof msg !== 'object') return false;
  const m = msg as Record<string, unknown>;
  if (m.source !== expectedSource) return false;
  if (m.protocolVersion !== PROTOCOL_VERSION) {
    console.warn('[Mobeus] protocol version mismatch; dropping message');
    return false;
  }
  return typeof m.id === 'string' && typeof m.type === 'string';
}
